import PropTypes from 'prop-types'
import React from 'react'
import UserIcon from './icons/UserIcon'
import CogIcon from './icons/CogIcon'
import PhoneIcon from './icons/PhoneIcon'
import CloseSession from './icons/CloseSession'
import AddUser from './icons/AddUser'
import NoDataTable from './icons/NoDataTable'
import Cuna from './icons/Cuna'
import KeyIcon from './icons/KeyIcon'
import CloseIcon from './icons/CloseIcon'
import CheckIcon from './icons/CheckIcon'
import ViewIcon from './icons/ViewIcon'
import EyeIcon from './icons/EyeIcon'
export const iconNames = {
  user: 'user',
  userAdd: 'userAdd',
  cog: 'cog',
  phone: 'phone',
  closeSesion: 'closeSesion',
  noDataTable: 'noDataTable',
  cuna: 'cuna',
  keyIcon: 'keyIcon',
  closeIcon: 'closeIcon',
  checkIcon: 'checkIcon',
  viewIcon: 'viewIcon',
  eyeIcon: 'eyeIcon',
}

export const icons = {
  user: UserIcon,
  userAdd: AddUser,
  cog: CogIcon,
  phone: PhoneIcon,
  closeSesion: CloseSession,
  noDataTable: NoDataTable,
  cuna: Cuna,
  keyIcon: KeyIcon,
  eyeIcon: EyeIcon,
  closeIcon: CloseIcon,
  checkIcon: CheckIcon,
  viewIcon: ViewIcon,
}

export default function SvgIcon({ iconName, color }) {
  const IconComponent = icons[iconName]
  const iconStyle = {
    fill: color,
    color,
  }
  return <IconComponent styles={iconStyle} />
}

SvgIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  color: PropTypes.string,
}
